/**
 * Módulo de autenticación del frontend.
 *
 * Centraliza las llamadas al backend relacionadas con autenticación
 * (validate-access) para evitar duplicación en LoginPage y otros.
 */
import { apiPost } from './apiClient';

/**
 * Valida si un email tiene acceso al portal (whitelist).
 *
 * @param {string} email   Email del usuario
 * @param {string} name    Nombre descriptivo (opcional)
 * @param {'sso'|'emergency'} method  Método de autenticación
 * @returns {Promise<object>}  Data de validación del backend
 * @throws {Error}  Si el acceso es denegado o hay error de red
 */
export async function validateAccess(email, name, method = 'sso') {
  return apiPost('/api/auth/validate-access', {
    email,
    name,
    method,
  });
}

export default { validateAccess };
